module.exports = __webpack_public_path__ + "media/images/Group 19-f5a7b8c6839c22a64ebbdb70a1d87a3b.png";